import scrollPadding from './scrollOptions';


const scrollPoints = {
  '#about_us': {
    to: 'about_us',
    pad: scrollPadding.header,
    title: "About Us"
  },
  '#location': {
    to: 'location',
    pad: scrollPadding.headerAndHorizLine,
    title: "Location"
  },
  '#hours': {
    to: 'hours',
    pad: scrollPadding.headerAndHorizLine,
    title: "Hours"
  },
  '#kids_pond': {
    to: 'kids_pond',
    pad: scrollPadding.headerAndHorizLine,
    title: "Kids Pond"
  },
  '#admissions': {
    to: 'adminssions',
    pad: scrollPadding.headerAndHorizLine,
    title: 'Admissions'
  },
  '#contact': {
    to: 'contact',
    pad: scrollPadding.headerAndHorizLine,
    titile: 'Contact'
  }
}
export  default scrollPoints;



// WEBPACK FOOTER //
// ./src/components/home/utils/scrollPoints.js